import { render } from "./ArchivePage.vue?vue&type=template&id=42c1ef7e&scoped=true"
import script from "./ArchivePage.vue?vue&type=script&lang=js"
export * from "./ArchivePage.vue?vue&type=script&lang=js"

import "./ArchivePage.vue?vue&type=style&index=0&id=42c1ef7e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42c1ef7e"]])

export default __exports__